export default __webpack_public_path__ + "static/media/gambar-0.f22de042.png";